import React from 'react';
import Slider from 'react-slick';
import './Team.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import firstteam from '../assets/img/team/about.jpg';
import akash from '../assets/img/team/akash.jpeg';

const teamMembers = [
  {
    name: 'Dr. R.R. Joshi',
    role: 'Founder',
    img: firstteam,
  },
  {
    name: 'Akash Bhor',
    role: 'Operational Director',
    img: akash,
  },
  // Add more team members as needed
];

const Team = () => {
    const settings = {
        dots: true,
        infinite: teamMembers.length > 3,
        slidesToShow: teamMembers.length > 2 ? 3 : teamMembers.length,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: teamMembers.length > 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };
      

  return (
    <div className="team-container">
      <h2 className="team-title">Meet Our Team</h2>
      <div className="why-thermal-line"></div>
      <Slider {...settings}>
        {teamMembers.map((member, index) => (
          <div key={index} className="team-card">
            <div className="team-image-wrapper">
              <img src={member.img} alt={member.name} className="team-image" />
              <div className="overlay">
                <div className="text">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Team;
